<template>
  <component
    :is="tagName"
    :role="role"
    class="oct-menu-item-group"
  >
    <!-- Title -->
    <span class="oct-menu-item-group__title">
      {{ title }}
    </span>

    <slot />
  </component>
</template>

<script>
export default {
  name: 'OctMenuItemGroup',
  props: {
    /** Tag name */
    tagName: {
      type: String,
      default: 'li'
    },
    /** Title */
    title: {
      type: String,
      default: ''
    },
    /** Native role attribute */
    role: {
      type: [String, null],
      default: 'menuitem'
    },
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-menu-item-group {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: oct-rem(8);
}

.oct-menu-item-group__title {
  font-size: oct-rem(12);
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  display: block;
  overflow: hidden;
}
</style>
